import { INVALID_FRAME_ANCESTORS_REGEX } from '@bettermode/common/utils'

export const getInvalidDomains = (input: string) => {
  if (!input) {
    return []
  }

  const entries = input
    .split(',')
    .map(entry => entry.trim())
    .filter(Boolean)

  return entries.filter(entry => INVALID_FRAME_ANCESTORS_REGEX.test(entry))
}
